import React, { useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { isAdmin } from 'cms/utils';
import CustomModal from 'cms/components/shared/CustomModal';
import VideoGalleriesController from '../controller/VideoGalleriesController';
import VideoGalleryForm from './VideoGalleryForm';
import VideoGalleryItem from './video_gallery_item';
import VideoGalleryCategoryForm from './VideoGalleryCategoryForm';
import VideoGalleryCategoryList from './VideoGalleryCategoryList';
import SelectCourses from '../../../../components/SelectCourses';

function VideoGalleriesList() {
  const location = useLocation();
  const history = useHistory();
  const [categoryModalIsOpen, setCategoryModalIsOpen] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const [editingItem, setEditingItem] = useState(null);
  
  const { galleries, setGalleries, show_delete, showDelete, setAddModalIsOpen, addModalIsOpen, closeModal } = VideoGalleriesController()

  const searchParams = new URLSearchParams(location.search);
  const courseFilter = searchParams.get('course');

  const onCourseFilter = (value) => {
    const p = new URLSearchParams(location.search);
    if (value == null || value === '' || value === 0) {
      p.delete('course');
    } else {
      p.set('course', String(value));
    }
    const qs = p.toString();
    history.replace({ pathname: location.pathname, search: qs ? `?${qs}` : '' });
  };
  return (
    <div className="content-wrapper">
      

      <section className="content mb-30">
        <div className="container-fluid">
          <div className="row users-filter-page-row">
            <div className="col-md-12 users-filter-page-col">
              <div className="box box-primary">
              <div className="box-header with-border">
                <div className="clearfix">
                  <h3 className="box-title pull-left">
                    Video gallery
                    <span style={{ fontSize: 11, marginLeft: '0.35em' }}>({galleries ? galleries.length : 0})</span>
                  </h3>
                  {isAdmin() && (
                    <div className="pull-right">
                      <button type="button" title="Add New" onClick={() => { setAddModalIsOpen(true) }} className="btn btn-cm mx-1"><i className="fa fa-plus"></i></button>
                      <button type="button" title="Categories" onClick={() => { setCategoryModalIsOpen(true) }} className="btn btn-cm mx-1"><i className="fa fa-folder"></i></button>
                      <button type="button" title="Show Delete Button" className="btn btn-cm mx-1" onClick={showDelete}><i className="fa fa-trash"></i></button>
                      <SelectCourses
                        width="220px"
                        value={courseFilter != null && courseFilter !== '' ? Number(courseFilter) : null}
                        callback={(v) => onCourseFilter(v)}
                        placeholder="Filter by contest"
                      />
                    </div>
                  )}
                </div>
                
              </div>
              <div className="box-body no-padding">
                <div className="talent-cards-grid video-gallery-cards-grid">
                  {galleries && galleries.map(item => (
                    <VideoGalleryItem key={item.id} item={item}
                      showDelete={show_delete}
                      onEdit={isAdmin() ? () => setEditingItem(item) : undefined}
                      onDelete={(id) => {
                        let temp = galleries.filter(item => item.id !== id)
                        setGalleries(temp)
                      }} />
                  )
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </section>

      {addModalIsOpen &&
        <CustomModal
          title=""
          isOpen={addModalIsOpen}
          setIsOpen={setAddModalIsOpen}
          overlayClassName="Overlay Overlay--video-gallery-cms"
          modalClassName="Modal--video-gallery-add"
          bodyClassName="modal-body--video-gallery-add"
        >
          <VideoGalleryForm
            initialCourse={courseFilter != null && courseFilter !== '' ? Number(courseFilter) : null}
            callback={(item) => {
            let temp = [item, ...(galleries || [])]
            setGalleries(temp)
            setAddModalIsOpen(false);
          }} />
        </CustomModal>
      }

      {editingItem &&
        <CustomModal
          title=""
          isOpen={!!editingItem}
          setIsOpen={(open) => { if (!open) setEditingItem(null) }}
          overlayClassName="Overlay Overlay--video-gallery-cms"
          modalClassName="Modal--video-gallery-add"
          bodyClassName="modal-body--video-gallery-add"
        >
          <VideoGalleryForm
            key={editingItem.id}
            editingItem={editingItem}
            initialCourse={courseFilter != null && courseFilter !== '' ? Number(courseFilter) : null}
            callback={(data) => {
              setGalleries((galleries || []).map((g) => (g.id === data.id ? { ...g, ...data } : g)))
              setEditingItem(null)
            }}
          />
        </CustomModal>
      }

      {categoryModalIsOpen &&
        <CustomModal
          showHeader={false}
          isOpen={categoryModalIsOpen}
          setIsOpen={setCategoryModalIsOpen}
        >
          <div className="row">
            <div className="col-md-6">
              <VideoGalleryCategoryForm callback={(item) => {
                setRefresh(refresh+1)
              }} />
            </div>
            <div className="col-md-6">
              <VideoGalleryCategoryList key={refresh+"rfc"} />
            </div>
          </div>
        </CustomModal>
      }


    </div>
  )
}

export default VideoGalleriesList